import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-step-bar',
  imports: [TranslatePipe, MatIcon],
  templateUrl: './step-bar.html',
  styleUrl: './step-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(keydown.escape)': 'collapse()' },
})
export class StepBar {
  public readonly labels = input.required<readonly string[]>();
  public readonly selectedIndex = input.required<number>();
  public readonly completed = input.required<readonly boolean[]>();
  public readonly selected = output<number>();

  protected readonly expanded = signal(false);

  private readonly toggle = viewChild.required<ElementRef<HTMLButtonElement>>('toggle');

  protected flip(): void {
    this.expanded.update((expanded) => !expanded);
  }

  protected collapse(): void {
    if (!this.expanded()) {
      return;
    }

    this.expanded.set(false);
    this.toggle().nativeElement.focus();
  }

  protected choose(index: number): void {
    this.collapse();

    if (index === this.selectedIndex()) {
      return;
    }

    this.selected.emit(index);
  }
}
